import * as React from "react";
const NewsSocial5 = (props) => (
  <svg
    width={22}
    height={22}
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22 11C22 17.0751 17.0751 22 11 22C4.92487 22 0 17.0751 0 11C0 4.92487 4.92487 0 11 0C17.0751 0 22 4.92487 22 11ZM11.3941 8.12068C10.3243 8.5657 8.18595 9.48673 4.97923 10.8838C4.4585 11.091 4.18572 11.2936 4.16089 11.4916C4.11893 11.8264 4.53815 11.9582 5.109 12.1377C5.18667 12.1622 5.26712 12.1875 5.3496 12.2142C5.91123 12.3968 6.66675 12.6104 7.0595 12.6189C7.41577 12.6266 7.81341 12.4797 8.25241 12.1782C11.2486 10.1558 12.7952 9.13352 12.8922 9.11141C12.9607 9.0959 13.0557 9.07632 13.12 9.13352C13.1844 9.19072 13.178 9.29896 13.1712 9.328C13.1297 9.5051 11.4841 11.035 10.6325 11.8267C10.3671 12.0735 10.1787 12.2485 10.1402 12.2885C10.054 12.3781 9.96611 12.4628 9.88163 12.5442C9.3599 13.0472 8.96852 13.4244 9.9033 14.0404C10.3525 14.3364 10.7119 14.5812 11.0705 14.8254C11.4621 15.0921 11.8527 15.3581 12.3582 15.6894C12.4869 15.7738 12.6098 15.8615 12.7296 15.9468C13.1854 16.2718 13.5948 16.5637 14.1007 16.517C14.3946 16.4901 14.6982 16.2137 14.8524 15.3893C15.2169 13.4412 15.9332 9.2202 16.0987 7.48089C16.1132 7.32851 16.095 7.13348 16.0804 7.04787C16.0656 6.96225 16.035 6.84026 15.9237 6.74996C15.7919 6.64302 15.5885 6.62047 15.4975 6.622C15.0838 6.62937 14.4489 6.85008 11.3941 8.12068Z"
      fill={props.color}
    />
  </svg>
);
export default NewsSocial5;
